
import TagUser from "../../../assets/duotone/TagUser.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TagUserIcon({ className, dataTestid = "TagUserIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TagUser data-testid={dataTestid} className={classes} {...rest} />
  );
}
